<template>
  <div class="p-6">
    <!-- Tab Navigation -->

    <!--  -->
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <a href="/setting/org_info">
          <div class="card p-2 m-1 custom-menuit">
            <h4>Org Info</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Contacts, Logo, info,,,</span
            >
          </div></a
        >
      </div>

      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <a href="services/lab"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>Services Setting</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Labs, Rad, nusing Servi...</span
            >
          </div></a
        >
      </div>

      <div
        v-if="package_contains('dialysis')"
        class="col-xl-3 col-sm-6 mb-xl-0"
      >
        <a href="/setting/dialysis"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>Dialysis Setting</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Charges, Behavior..</span
            >
          </div></a
        >
      </div>

      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <a href="/system_users"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>User Setting</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Users, roles, permissions...</span
            >
          </div></a
        >
      </div>

      <div
        v-if="package_contains('inpatient')"
        class="col-xl-3 col-sm-6 mb-xl-0"
      >
        <a href="bed_setting"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>Bed Setting</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Wards,beds,charges...</span
            >
          </div></a
        >
      </div>

      <div
        v-if="$store.getters.currentCompany == 'Medley HMS System'"
        class="col-xl-3 col-sm-6 mb-xl-0"
      >
        <a href="backoffice_create_organization"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>New Facility</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Add a new facility</span
            >
          </div></a
        >
      </div>

      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <a href="insurance_settings"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>Insurance</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >companies, schemes, etc---</span
            >
          </div></a
        >
      </div>

      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <a href="additional_settings"
          ><div class="card p-2 m-1 custom-menuit">
            <h4>Other Settings</h4>
            <span style="font-size: 0.8em; color: grey; font-weight: 400"
              >Bill actions, etc---</span
            >
          </div></a
        >
      </div>
    </div>

    <!--  -->
  </div>
</template>

<script>
import package_contains from "../special_clinics/package_contains";
export default {
  data() {
    return {
      activeTab: "company",
      tabs: [
        { name: "company", label: "Company Info" },
        { name: "lab", label: "Lab Tests" },
        { name: "radiology", label: "Radiology Services" },
        { name: "nursing", label: "Nursing Services" },
        { name: "categories", label: "Categories" },
        { name: "billing", label: "Billing Settings" },
      ],
    };
  },
  // mounted() {
  //   const company = this.$store.getters.currentCompany;
  //   console.log("====iiiiiiiiiiiiiiiiiiiiiiiiiiiiiii============");

  //   console.log(company);
  // },
  methods: {
    package_contains,
  },
};
</script>

<style scoped>
body {
  font-family: "Inter", sans-serif;
}
.custom-menuit {
  display: flex;
  align-self: center;
  align-items: center;
  color: black;
  font-weight: bold;
}

.custom-menuit:hover {
  background-color: bisque;
  border: 1px solid black;
}
</style>
